/**
 * loadjs加载器
 * // 单个加载
 * loadJs("http://sc.qq.com/a.js", function(data) {
 *     console.log(data);
 * });
 * // 多个加载
 * loadJs(["http://sc.qq.com/a.js", "http://sc.qq.com/b.js"], function(data) {
 *     console.log(data);
 * });
 */
function loadSinglejs(url, callback) {
    var head = document.getElementsByTagName("head")[0];
    var script = document.createElement('script');
    script.onload = script.onreadystatechange = script.onerror = function () {
        if (script && script.readyState && /^(?!(?:loaded|complete)$)/.test(script.readyState))
            return;
        script.onload = script.onreadystatechange = script.onerror = null;
        callback();
    };
    script.charset = "utf-8";
    script.src = url;
    try {
        head.appendChild(script);
    }
    catch (exp) { }
}
;
export default function loadJs(url) {
    return new Promise(function (resolve) {
        if (Object.prototype.toString.call(url) === '[object Array]') { //是否数组
            var suc_1 = 0; //加载计数
            var len_1 = url.length; //数组长度
            for (var i = 0; i < url.length; i++) {
                loadSinglejs(url[i], function () {
                    suc_1++;
                    if (suc_1 === len_1) {
                        resolve(url);
                    }
                });
            }
        }
        else if (typeof (url) == 'string') {
            loadSinglejs(url, function () {
                resolve(url);
            });
        }
    });
}
;
